<template lang="html">
  <div class="pagination">
    <nav class="pages">
      <button class="change-btn" :disabled="this.onFirstPage" @click="prevPage">
        <rp-sprite name="chevron_left" />
      </button>

      <ul class="page-items">
        <li
          v-if="!pageLimit"
          v-for="(page, index) in this.totalPages"
          class="desktop-pagination"
          :class="{ 'is-active' : (page === currentPage) }"
          @click="changePage(page)"
          :key="`d-${index}`">
          <span>{{page}}</span>
        </li>

        <li :class="{'is-concat': pageLimit}" class="mobile-pagination">
          <span>{{currentPage}} / {{totalPages}}</span>
        </li>
      </ul>

      <button class="change-btn" :disabled="this.onLastPage" @click="nextPage">
        <rp-sprite name="chevron_right" />
      </button>
    </nav>

    <div class="per-page">
      <span class="per-page-label">Per page:</span>

      <select v-model="currentPageSize">
        <option
          v-for="option in paginationOptions"
          :value="option"
          :key="option">
          {{option}}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
  import Sprite from './Sprite'

  const FIRST_PAGE = 1
  const CHANGE_BY = 1
  const MAX_PAGES = 10

  export default {
    name: 'Pagination',

    components: {'rp-sprite': Sprite},

    props: {
      pageInfo: Object
    },

    data() {
      return {
        paginationOptions: [10, 25, 50, 100]
      }
    },

    computed: {
      currentPage: {
        get() {
          return this.pageInfo.page_number
        },

        set(value) {
          const currentPage = {
            page: value,
            page_size: this.currentPageSize
          }

          this.$emit('getData', currentPage)
        }
      },

      currentPageSize: {
        get() {
          return this.pageInfo.page_size
        },

        set(value) {
          const currentPage = {
            page: FIRST_PAGE,
            page_size: value
          }

          this.$emit('getData', currentPage)
        }
      },

      totalPages() {
        return this.pageInfo.total_pages
      },

      onFirstPage() {
        return this.currentPage === FIRST_PAGE
      },

      onLastPage() {
        return this.currentPage === this.totalPages
      },

      pageLimit() {
        return this.totalPages >= MAX_PAGES
      }
    },

    methods: {
      prevPage() {
        this.changePage(Math.max(FIRST_PAGE, this.currentPage - CHANGE_BY))
      },

      nextPage() {
        this.changePage(Math.min(this.totalPages, this.currentPage + CHANGE_BY))
      },

      changePage(page) {
        this.currentPage = page
      }
    }
  }
</script>

<style lang="sass">
  @import '../../styles/main'

  .pagination
    padding: 25px 0
    position: relative

    @include media($media-small)
      display: flex
      justify-content: center

    .change-btn
      cursor: pointer
      background: none
      border: none

      .sprite
        margin: 0

    .pages, .page-items
      display: flex
      padding: 0
      list-style: none

    .pages
      justify-content: center
      align-items: center

      li
        padding: 10px
        cursor: pointer

    .per-page
      position: absolute
      top: 50%
      transform: translateY(-50%)
      right: 0
      margin: 0

      select
        border: 1px solid grey
        min-width: 50px
        padding: 5px 2px
        appearance: none
        border-radius: 0
        background: none
        border: none

        &:focus
          outline: none

    .per-page-label
      font-size: 9px

      @include media($media-medium)
        font-size: 12px
        top: -1px

    .is-active
      font-weight: bold
      color: $color-primary
      text-decoration: underline

    .sprite
      width: 15px
      height: 20px
      opacity: 0.5

  .desktop-pagination
    display: none

    @include media($media-small)
      display: block

  .mobile-pagination
    @include media($media-small)
      display: none

    &.is-concat
      display: block
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Pagination.vue